/** Reserve space for dashboard horizontal minimap (bottom offset + panel + track). */
export const DASHBOARD_MINIMAP_CLEARANCE_PX = 80;

/** Gap between trigger and menu panel (`DropdownMenuStyled.margin-top`). */
const MENU_GAP_PX = 8;

/** Conservative fallback when menu height is not yet measurable. */
export const DROPDOWN_MENU_HEIGHT_FALLBACK_PX = 320;

export const DASHBOARD_BOARD_SCROLL_SELECTOR = "[data-dashboard-board-scroll]";
export const getDropdownVisibleBottom = (triggerEl: HTMLElement): number => {
  const scrollEl = triggerEl.closest(DASHBOARD_BOARD_SCROLL_SELECTOR);
  if (scrollEl instanceof HTMLElement) {
    return (
      scrollEl.getBoundingClientRect().bottom - DASHBOARD_MINIMAP_CLEARANCE_PX
    );
  }

  return window.innerHeight - 16;
};

/** Returns true when the menu should render above the trigger instead of below. */
export const shouldFlipDropdownMenuUp = (
  triggerEl: HTMLElement,
  menuEl?: HTMLElement | null,
): boolean => {
  const triggerRect = triggerEl.getBoundingClientRect();
  const visibleBottom = getDropdownVisibleBottom(triggerEl);
  const spaceBelow = visibleBottom - triggerRect.bottom - MENU_GAP_PX;

  const measuredHeight = menuEl?.getBoundingClientRect().height ?? 0;
  const menuHeight =
    measuredHeight > 0 ? measuredHeight : DROPDOWN_MENU_HEIGHT_FALLBACK_PX;

  return spaceBelow < menuHeight;
};
